import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { httpClient, httpClientStream } from '@/app/shared/services/http-client/http-client.js';
export class BGAssignmentService {

    constructor() {
        this.getContractorsActiveList =
            modelServices.baseUrl + modelServices.getBillingMgtODataServiceName("ContractorActiveOData").URL + "$top=20";
    }
    
    GetProductClassifications(callback, errCallback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("GetProductClassifications").URL;
        return httpClient.get(url).then(callback).catch(errCallback);
    }
    GetProductCategories(productClassificationID, callback, errCallback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("GetProductCategories").URL + productClassificationID;
        httpClient.get(url).then(callback).catch(errCallback);
    }

    GetProdCategories(productClassificationID, callback, errCallback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("GetProdCategories").URL + productClassificationID;
        httpClient.get(url).then(callback).catch(errCallback);
    }
    GetProductsURL() {
        return modelServices.baseUrl + modelServices.getBillingMgtODataServiceName("GetBillingGroupAssignmentProducts").URL;
    } 

    GetProductsAssignedURL() {
        return modelServices.baseUrl + modelServices.getBillingMgtODataServiceName("GetBillingGroupAssignProducts").URL;
    } 

    GetBillingGroupTree(callback) {
        return httpClient.get(modelServices.baseUrl + modelServices.getBillingMgtServiceName("BillingGroupAssignmentBillingGroupTree").URL).then(callback);
    }

    //download
    //"&ProductCategoryID=" + this.formData.productCategoryIDs.toString() + "&ContractorId=" + this.formData.contractorID + "&IsNotCoverd=" + this.formData.IsNotCoverd + "&IsAssigned=" + this.formData.assignStatus.toString(), config.pageSize, "ID",
    downloadExcel(productCategoryIDs,contractorID,isNotCoverd,isAssigned, callback, errCallback) {
        httpClientStream.get(modelServices.baseUrl + modelServices.getBillingMgtServiceName("DownloadExcelFileForProducts").URL
         + "?ProductCategoryID=" + productCategoryIDs + "&ContractorId=" + contractorID + "&IsNotCoverd=" + isNotCoverd + "&IsAssigned=" + isAssigned).then(callback).catch(errCallback);
    }
    uploadFiles(file, contractorID , callback, errCallback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("UploadExcelFileForProducts").URL + "?contractorID=" + +(contractorID);
        const options = {
            url: url,
            method: 'POST',
            data: file
        };
        httpClientStream(options).then(callback).catch(errCallback);
    }

    
    AddContractorIsCoveredConfigration(contractorID, isNotCovered, callback) {
       const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("AddContractorIsCoveredConfigration").URL + "?ContractorId=" + contractorID + "&IsNotCoverd=" + isNotCovered;
       httpClient.post(url).then(callback);
    }

    GetBillingGroupsByProductID(productId,contractorId, callback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("GetBillingGroupsByProductID").URL + "?ProductId=" + productId+"&ContractorID="+contractorId;
        httpClient.get(url).then(callback);
     }
    AddProductBillingGroup(model, callback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("AddProductBillingGroup").URL;
        const options = {
            url: url,
            method: 'POST',
            data: JSON.stringify(model)
        };
        httpClient(options).then(callback);
    }
    DeleteProductBillingGroup(productBillingGroupID, modifiedTs, callback, errCallback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("DeleteProductBillingGroup").URL + "?ProductBillingGroupID=" + productBillingGroupID + "&ModifiedTS=" + modifiedTs;
        return httpClient.delete(url).then(callback).catch(errCallback);
    }

    GetLocalNationality(callback, errCallback) {
        const url = modelServices.baseUrl + modelServices.getBillingMgtServiceName("GetLocalNationality").URL;
        return httpClient.get(url).then(callback).catch(errCallback);
    }
   

}

const billingGroupAssignmentService = new BGAssignmentService();

export { billingGroupAssignmentService };